import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";
import { Divider } from '../components/Divider';

import cover from "../assets/img/watership.webp";
import { Container } from 'react-bootstrap';


export const projectDetails: ProjectInterface = {
    url: "3d-modeling",
    title: "3D Modeling",
    summary: "A collection of some 3D models I've created.",
    description: ``,
    year: "",
    tags: ["Game Assets", "Low-poly", "Texturing", "Blender"],
    imageSrc: cover,
    hasVideo: false,
    startVideoTime: 0,
    videoSrc: "",
    isCoverType: true,
    haveTags: false,
    projectType: ProjectType.SIDE,
    roles: ["Collection", "3D", "Hobby"],
    technologies: ["3D", "Blender", "Photoshop"],
    collaborators: ["Lucas Coutinho"],
    highlightColor: "#60151F",
    descriptionTitle: "",
    linkData:
        [
        ]
};


export function Models() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                leftContent={
                    <div className="a-left-no-bg">
                    </div>
                }
                rightContent={
                    <div className="a-right-no-bg">
                    </div>
                }>

                <Container className="a-body">
                    <Divider width={100} />
                </Container>
            </ProjectBase>
        </div>
    );
}